import React, { useState } from "react";
import "../../styles.css";
import "./about-us.css";
import { ContactSection, ScrollToTop, WhatWeDoSection } from "../../components";
import { Link } from "react-router-dom";
import ceoLogo from "../../assets/img/owner.png";
import team2 from "../../assets/img/secretary.png";
import itmanager from "../../assets/img/itmanager.jpeg";
import { aboutContent } from "../../data";
import {
  useFounderSection,
  useAboutSection,
  useTeamSection,
} from "../../hooks/aboutSectionHooks";
import { PortableText } from "@portabletext/react";
import { urlFor } from "../../lib/sanity";
import { portableTextComponents } from "../../components/PortableTextComponents";

const AboutUs = () => {
  const {
    title: founderTitle,
    description: founderDesc,
    image,
    loading: founderLoading,
    error: founderError,
  } = useFounderSection();
  const {
    title: aboutTitle,
    description: aboutDesc,
    leftColumn,
    rightColumn,
    loading: aboutLoading,
    error: aboutError,
  } = useAboutSection();
  const {
    title: teamTitle,
    description: teamDesc,
    teamMembers,
    loading: teamLoading,
    error: teamError,
  } = useTeamSection();
  const [readMore, setReadMore] = useState(false);

  if (founderLoading || aboutLoading || teamLoading) {
    return <div>Loading...</div>;
  }

  if (founderError || aboutError || teamError) {
    return <div>Error: {founderError || aboutError || teamError}</div>;
  }

  return (
    <>
      {/* ceo section */}
      <section className="ceo-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="ceo-bg">
                <img
                  src={image ? urlFor(image).url() : ceoLogo}
                  className="ceo-img"
                  alt="ceo"
                />
              </div>
            </div>

            <div className="col-md-6 mt-lg-0 mt-4">
              <h1>{founderTitle || aboutContent.title}</h1>
              {/* <div className="subtitle">
                <h2>Crafted Excellence in Legal Advocacy</h2>
              </div> */}
              <div className={`about-desc ${readMore ? "expanded" : ""}`}>
                {founderDesc && founderDesc.length > 0 ? (
                  <PortableText
                    value={founderDesc}
                    components={portableTextComponents}
                  />
                ) : (
                  aboutContent.desc
                )}
              </div>
              {!readMore && (
                <span className="read-more" onClick={() => setReadMore(true)}>
                  read more
                </span>
              )}
              {readMore && (
                <span className="read-more" onClick={() => setReadMore(false)}>
                  read less
                </span>
              )}{" "}
              <br />
              <br />
              <Link to="/our-services" className="btn-blue d-block">
                Our Services
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* our founder */}
      <section className="our-founder pt-lg-5 pt-2 pb-4 mt-4">
        <div className="container">
          <h1 className="mb-3">{aboutTitle || "About Us"}</h1>

          <div className="row">
            <div className="col-md-6">
              {aboutDesc && aboutDesc.length > 0 && (
                <PortableText
                  value={leftColumn}
                  components={portableTextComponents}
                />
              )}
            </div>

            <div className="col-md-6">
              {aboutDesc && aboutDesc.length > 0 && (
                <PortableText
                  value={rightColumn}
                  components={portableTextComponents}
                />
              )}
            </div>
          </div>
        </div>
      </section>

      {/* our team */}
      <section className="our-team pb-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-3 pr-0">
              <h1>{teamTitle || "Our Team"}</h1>
            </div>
            <div className="col-md-9 pl-lg-0 pl-auto">
              <p className="mb-0">{teamDesc}</p>
            </div>
          </div>

          <div className="row mt-5 justify-content-center">
            {teamMembers &&
              teamMembers.map((member, i) => (
                <div className="col-md-6 col-lg-4 mb-3" key={i}>
                  <div className="card">
                    <div className="card-body">
                      <img
                        src={member.imageUrl || member.img}
                        className="img-fluid"
                        alt="team photo"
                      />
                    </div>
                    <div className="card-foot">
                      <h4>{member.name}</h4>
                      <p className="mb-2 mt-0">{member.position}</p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>

      <WhatWeDoSection />

      <ContactSection />

      <ScrollToTop />
    </>
  );
};

export default AboutUs;
